export default __webpack_public_path__ + "static/media/Moda.aff926be.png";